export default __webpack_public_path__ + "static/media/glucose.40c593ed.png";